<style lang="less" scoped>
.station-piles-div {
  .title-btn-div {
    .left-title-div {
      font-size: 16px;
      font-weight: 600;
      color: rgba(0, 0, 0, 1);
      line-height: 36px;
    }

    margin-bottom: 16px;
  }

  .station-pile-location-div {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 16px;

    .over-hide-station-img-div {
      width: 1000px;
      height: 540px;
      border-radius: 10px;
      border: 1px solid #ededed;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      .station-img {
        max-width: 1000px;
        max-height: 540px;
      }
    }
  }
}

.pile-dragable-icon {
  cursor: move;
}

.pile-table-drag-icon-div {
  display: flex;
  justify-content: center;
  align-items: center;
}

.sel-pile-span {
  width: 12px;
  height: 12px;
  background-color: #f0eaea;
  border-radius: 50%;
  display: inline-block;
  margin-right: 4px;
}

.cur-sel-pile-span {
  width: 12px;
  height: 12px;
  background-color: #69da16;
  border-radius: 50%;
  display: inline-block;
  margin-right: 4px;
}

.add-piles-title {
  font-size: 14px;
  font-weight: 500;
  color: #555;
  line-height: 32px;
}

.has-sel-piles-div {
  display: flex;
  flex-wrap: wrap;

  .sel-pile-child-div {
    margin: 0 10px 10px 0;
  }
}

.station-pile-action-span {
  text-decoration: underline;
  margin-right: 10px;
  cursor: pointer;
  color: #bb87f3;
}

.fixed-set-location-div {
  position: absolute;
  right: 0;
  top: 0;
}

.check-tip {
  color: #f56c6c;
  font-size: 12px;
}

.star {
  color: #f56c6c;
  margin: 10px -39px 0px 34px;
}

.img-star {
  color: #f56c6c;
  margin: 10px -24px 0px 20px;
}

/deep/ .hide .el-upload--picture-card {
  display: none;
}

.margin-right-15 {
  margin-right: 15px;
}

.search-input-div {
  margin-bottom: 10px;
}

.station-name {
  align-items: center;

  .station-button {
    width: 200px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.controlA {
  color: gray;
  pointer-events: none;
}
.font {
  font-size: 20px;
  margin-top: 10px;
}
</style>
<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb
        :bConfigList="pageConfig.detailBreadCrumb"
      ></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>
      <div class="detail-content-body-div flex-1">

          <div class="flex detail-form-parent-div">
            <div class="flex-1">
                <el-row :gutter="16">
                  <el-col :span="8">
                    <div class="font">发票类型：{{ detailForm.invoicingType == '01' ? '普通发票':'增值税专用发票' }}</div>
                    <div class="font">抬头类型：{{ detailForm.invoicingHeaderStatus == '01' ? '个人':'企业' }}</div>
                    <div class="font">名    称：{{ detailForm.enterpriseName  }}</div>
                    <div class="font">税    号：{{ detailForm.taxNumber }}</div>
                    <div class="font">订单类型：{{ detailForm.invoicingHeaderStatus == '01' ? '个人':'企业' }}</div>
                    <div class="font">订单金额：{{ detailForm.invoicableAmount }}</div>
                    <div class="font">开票金额：{{ detailForm.invoicableAmount}}</div>
                    <div class="font">企业地址：{{ detailForm.businessAddress  }}</div>
                    <div class="font">电话号码：{{ detailForm.enterprisePhone  }}</div>
                    <div class="font">接收邮箱：{{ detailForm.custEmail	 }}</div>
                    <div class="font">申请时间：{{ detailForm.createdWhen  }}</div>
                    <div class="font">开票时间：{{ detailForm.invoicTime  }}</div>
                    <div class="font">开票备注：{{ detailForm.commitRemark  }}</div>
                    <div class="font">开票状态： {{
                detailForm.invoicingStatus == "00"
                  ? "不可开票"
                  : detailForm.invoicingStatus == "01"
                  ? "未开票"
                  : detailForm.invoicingStatus == "02"
                  ? "开票中"
                  : detailForm.invoicingStatus == "03"
                  ? "已开票"
                  : detailForm.invoicingStatus == "04"
                  ? "未成功"
                  : detailForm.invoicingStatus == "05"
                  ? "待审核"
                  : detailForm.invoicingStatus == "06"
                  ? "审核通过"
                  : detailForm.invoicingStatus == "07"
                  ? "已拒开": ""
              }}</div>
                    <div class="font">
                      开票结果： {{
                        detailForm.nuoNuoStatus === '00' ? "推送成功"
                        : detailForm.nuoNuoStatus === '01' ? "推送失败"
                        : detailForm.nuoNuoStatus === '02' ? "开票完成"
                        : detailForm.nuoNuoStatus === '03' ? "发票已作废"
                        : detailForm.nuoNuoStatus === '04' ? "开票失败" : ''
                      }}
                    </div>
                    <div class="font" v-if="detailForm.nuoNuoStatus === '04'">
                      失败原因：{{ detailForm.moreRemarks }}
                    </div>
              <div class="font" v-if="detailForm.invoicingStatus == '07' ">拒开原因：{{ detailForm.reviewRemarks  }}</div>
                  </el-col>
                  <el-col :span="12">

                      <el-upload
                      action=""
                      :http-request="toUploadcontractFile"
                       :on-preview="handlePreview"
                       :on-remove="handleRemove"
                       :before-remove="beforeRemove"
                       multiple
                       :on-exceed="handleExceed"
                       :file-list="fileList"
                        :limit="1"
                        list-type="picture-card"
                      >
                        <i class="el-icon-plus"></i>
                        <!-- <div slot="tip" class="el-upload__tip">
                          (最新上传会覆盖原文件)
                        </div> -->
                      </el-upload>

                  </el-col>
                </el-row>
            </div>
          </div>

      </div>
      <!-- 站点充电桩 -->
      <div class="detail-content-footer-div">
        <button class="common-bg-button" v-if="detailForm.invoicingStatus == '05'" @click="handelPass">
          通过
        </button>
        <button class="common-bg-button" v-if="detailForm.invoicingStatus == '05'" @click="handleRefusal">拒开</button>
        <button class="common-bg-button" v-if=" detailForm.invoicingStatus == '03'" @click="handleVoid">作废</button>
        <button class="common-bg-button" v-if=" detailForm.nuoNuoStatus == '02'" @click="handleDown">下载发票</button>
      </div>
      <el-dialog
        :title="RefusalTitle"
        :visible.sync="RefusalDialogVisible"
        width="30%"
        style="position:relaative"
      >
        <span v-if="RefusalFlag" style="position:absolute; top:5%;left:20%;">
          <el-select v-model="RefusalForm.name" placeholder="请选择拒开原因">
            <el-option label="发票和税号抬头不一致" value="01"></el-option>
            <el-option label="接受发票邮箱格式不正确" value="02"></el-option>
            <el-option label="公司相关信息不正确" value="03"></el-option>
            <el-option label="其它问题" value="04"></el-option>
          </el-select>
        </span>
        <div>
          <el-input
            type="textarea"
            :rows="6"
            placeholder="请输入内容"
            v-model="RefusalForm.RefusalTextarea"
          >
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="RefusalDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="RefusalDialog">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx";
import gelLonLatMap from "../../../components/map/GetLonLatMap";
import VDistpicker from "v-distpicker";
import pageConfig from "./page-config";
import testStationImg from "../../../assets/test/area-map.jpg";
import pileOnImg from "../../../assets/detail/pile-on.png";
import pileOffImg from "../../../assets/detail/pile-off.png";
import Vue from "vue/dist/vue.js";
export default {
  components: {
    gelLonLatMap,
  },
  data() {
    return {
      invoicingNo:'',
        RefusalTitle: "",
      RefusalFlag: true,
        name:'已开票',
        fileList:[],
        passFlag:true,
        VoidFlag:true,
        RefusalDialogVisible:false,
        RefusalForm:{

        },
      pageConfig,
      pageTitle: "发票详情页",
      // 默认值设置
      detailForm: {},
      dialogPagination: {
        current: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
      }, // 弹窗查询条件
    };
  },
  methods: {
    /*
     *判断页面是新增还是编辑模式,如果是编辑模式获取当前页面的信息
     *@Api:
     *@Author:chenminghui
     *@Date: 2021-09-03 15:19:05 */
    init() {
        if(this.name == '待审核'){
            // console.log(1);
            this.VoidFlag = false
        }else{
            this.passFlag = false
        }
        this.invoicingNo = this.$route.query.detail
        // this.getDetail()
        this.detailForm = localStorage.getItem('invoicingDetail')?JSON.parse(localStorage.getItem('invoicingDetail')):''
        console.log(this.detailForm);
        if(this.detailForm.imgUrls){
          let imgObj = {}
          imgObj.name = 'invoicingLogo';
          imgObj.url = this.detailForm.imgUrls;
          this.fileList.push(imgObj);
        }
    },
    getDetail(){
      let _this = this
      _this.$H.post(_this,_this.$A.Billing.findByNo,{invoicingNo:_this.invoicingNo}).then(res=>{
        _this.detailForm = res.data.data
      })
    },
    // 通过
    handelPass(){
      this.$confirm("此操作将确认通过, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {

          let urlk =
            this.$A.Billing.requestBill + `?invoicingNo=${this.invoicingNo}`;
          this.$H.get(this, urlk).then((res) => {
            // this.getListData(this.pagination, true);
            // this.$message({
            //   type: res.data.data.code == "E0000" ? "success" : "info",
            //   message: res.data.data.describe,
            // });
          });
          let obj = {};
          let urlP =  this.$A.Billing.examine;
          obj.invoicingNo = this.invoicingNo
          obj.invoicingStatus = '06'
          this.$H.post(this, urlP, JSON.stringify(obj)).then((res) => {

            this.$message({
              type: "success",
              message: '审核通过',
            });
            this.$router.push('/custinvoicList')
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
     // 拒开
     handleRefusal() {
      this.RefusalDialogVisible = true;
      if ( this.detailForm.invoicingStatus == "05") {
        this.RefusalTitle = "拒开原因";
        this.RefusalFlag = true;
        this.invoicingStatus = this.detailForm.invoicingStatus;
        this.invoicingNo = this.detailForm.invoicingNo;
      }
    },
    // 作废
    handleVoid(val) {
      this.RefusalDialogVisible = true;
      if ( this.detailForm.invoicingStatus == "03") {
        this.RefusalTitle = "作废原因";
        this.RefusalFlag = false;
        this.invoicingStatus = this.detailForm.invoicingStatus;
        this.invoicingNo = this.detailForm.invoicingNo;
      }
    },
    // 下载发票
    handleDown() {
      let _ =this;
      let downloadDom = document.createElement('a');
      downloadDom.target = '_blank';
      downloadDom.href = _.detailForm.invoicUrl;
      document.body.appendChild(downloadDom);
      downloadDom.click();
      document.body.removeChild(downloadDom);
    },
    // 拒开弹出确认
    RefusalDialog(){
      let obj = {};
      if (
        this.invoicingStatus == "03" &&
        (this.RefusalForm.RefusalTextarea == "" ||
          this.RefusalForm.RefusalTextarea == null)
      ) {
        return this.$message.error("请填写作废原因");
      }
      if (this.invoicingStatus == "03") {
        obj.invoicingStatus = "08";
        obj.invoicingNo = this.invoicingNo;
        obj.reviewRemarks = this.RefusalForm.RefusalTextarea;
      } else {
        obj.invoicingStatus = "07";
        obj.invoicingNo = this.invoicingNo;
        obj.reviewRemarks = this.RefusalForm.RefusalTextarea;
      }

      this.$H.post(this, this.$A.Billing.examine, obj).then((res) => {
        this.getListData(this.pagination, true);
      });
      this.RefusalDialogVisible = false;
      this.$router.push('/custinvoicList')
    },
    /*
     *上传图片限制
     *@Api:
     *@Author:chenminghui
     *@Date: 2021-09-03 15:19:05 */
    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension1 = testmsg === "rar";
      const extension2 = testmsg === "zip";
      const extension3 = testmsg === "pdf";
      const extension4 = testmsg === "xlsx";
      const extension5 = testmsg === "docx";
      const isLt2M = file.size / 1024 / 1024 < 100; //这里做文件大小限制
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 100MB!");
        return false;
      }
      if (
        !extension1 &&
        !extension2 &&
        !extension3 &&
        !extension4 &&
        !extension5
      ) {
        this.$message.error("只能上传rar,zip,pdf,xlsx,docx格式");
        return false;
      }
      //return (extension1 || extension2 || extension3 || extension4 || extension5) && isLt2M;
      return true;
    },
    /*
     *上传入网申请文件
     *@Api:post;api/v1/pilestation/uploadFile
     *@Author:chenminghui
     *@Date: 2021-09-03 15:19:05 */
    toUploadcontractFile(param) {
      console.log(param);
      let _ = this;
      // _.stationFilesPath.push(param.file)
      // _.dealerFileDtoList.push({ name: param.file.name, path: param.file, time: _.$D.format(param.file.lastModifiedDate, 'Y-M-D H:m:s') })
      // let formData = new FormData();
      // let time = _.$D.format(param.file.lastModifiedDate, "Y-M-D H:m:s");
      // formData.append("uploadFile", param.file);
      // _.$H
      //   .postFormData(_, _.$A.pilestation.uploadFile, formData)
      //   .then((res) => {
      //     let obj = {
      //       name: res.data.data.newFileName,
      //       path: res.data.data.viewPath,
      //       time: time,
      //     };
      //     _.stationFilesPath.push(obj);
      //     _.dealerFileDtoList.push(obj);
      //   });
    },
    /*
     *删除入网申请表
     *@Api:
     *@Author:chenminghui
     *@Date: 2021-09-03 15:19:05 */
    handleRemove(file, fileList) {
      let filePath = "";
      if (file.path) {
        filePath = file.path;
      }
      filePath = file;
      console.log(filePath);
      this.fileList.forEach((item) => {
        console.log(item);
        if (item.url == filePath.url){
          this.fileList.splice(item, 1);
        }
      });
    },
    /*
     *查看入网申请表
     *@Api:
     *@Author:chenminghui
     *@Date: 2021-09-03 15:19:05 */
    handlePreview(file) {
      console.log(file);
      window.open(file.url);
    },
    //限制文件个数
    handleExceed(files, fileList) {
      console.log(files,fileList);
      // fileList.splice(0,1,files[0])
      // this.$message.error("每次只能上传一个文件,请先删除");
      // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      this.detailForm.imgUrls = '';
    },
    /*
     *表单提交 删除多余字段 并把对应字段转化为formData格式   如果非编辑状态提示保存成功 并在新的页面打开
     *@Api:put:api/v1/pilestation
     *@Author:chenminghui
     *@Date: 2021-09-03 15:19:05 */
    submitForm(formName) {
      let _ = this;
      // 站点图片
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!_.detailForm.rtLon) {
            _.mapFlag = true;
            return;
          } else {
            _.mapFlag = false;
          }
          if (!_.detailForm.province || !_.detailForm.city) {
            _.areaFlag = true;
            return;
          } else {
            _.areaFlag = false;
          }
          // 异常处理
          _.detailForm.chargeAmt = _.detailForm.chargeAmt || 0;
          _.detailForm.operDate = _.detailForm.operDate || "";
          _.detailForm.parkNum = _.detailForm.parkNum || 0;

          delete _.detailForm.pileEntityList;
          delete _.detailForm.pileStationAppImgDtoList;
          delete _.detailForm.pileStationRemarkDtoList;
          delete _.detailForm.pileStationRptDto;
          delete _.detailForm.pileLocationJson;
          delete _.detailForm.stationFilesPath;
          delete _.detailForm.fileName;
          delete _.detailForm.filePath;
          delete _.detailForm.fileTime;
          delete _.detailForm.pileChargeEntity; //删除多余字段
          // if(this.stationLocationFile == null){
          //     this.$U.error('请上传电站平面图');
          //     return;
          // }
          if (
            this.appStationFiles == null ||
            this.appStationFiles.length == 0
          ) {
            this.$U.error("请上传APP站点图");
            return;
          }
          let formData = new FormData();
          Object.keys(_.detailForm).forEach((key) => {
            if (_.detailForm[key] !== null) {
              formData.append(key, _.detailForm[key]);
            }
          });
          formData.append("file", _.stationLocationFile);
          _.appStationFiles.forEach((file) => {
            if (file.sort == undefined) {
              formData.append("files", file);
            }
          });
          //上传网点文件
          let fileName = [];
          let filePath = [];
          let fileTime = [];
          if (_.stationFilesPath.length != 0) {
            _.stationFilesPath.forEach((item) => {
              fileName.push(item.name);
              filePath.push(item.path);
              fileTime.push(item.time);
            });
          }
          formData.append("fileName", fileName.toString());
          formData.append("filePath", filePath.toString());
          formData.append("fileTime", fileTime.toString());
          let locationStr = JSON.stringify(_.stationLocationJson);
          formData.append("pileLocationJson", locationStr);
          if (_.editFlag) {
            _.$S.submitForm(
              _,
              _.$A.pilestation.pilestation,
              _.editFlag,
              formData,
              pageConfig.listRouter
            );
          } else {
            _.$S.submitForm(
              _,
              _.$A.pilestation.pilestation,
              _.editFlag,
              formData,
              false,
              "保存成功",
              function(res) {
                _.$store.commit("setEditId", res.data.data.id);
                _.init();
              }
            );
          }
        }
      });
    },
  },
  mounted() {
    // this.getPileListData(this.dialogPagination);
    this.init();
  },
};
</script>
